import utilsOrder from "./utils.order";

export function sortByDateDescending(collection) {
  if (!collection || !collection.length) return [];

  return collection.slice(0).sort(function(a, b) {
    if (a.date > b.date) return -1;

    if (a.date < b.date) return 1;

    return 0;
  });
}

/**
 * сортируем по order преданную коллекцию
 * @param {коллекция у которой должен быть order} collection
 */
export function sortByOrderInPlace(collection) {
  if (!collection || !collection.length) return collection;

  collection.sort((a, b) => utilsOrder.compare(a.order, b.order));
}

/**
 * создаст осортированныу копию коллекции по свойству order
 * @param {коллекция у которой должен быть order} collection
 */
export function sortByOrder(collection) {
  const ordered = [];
  if (!collection || !collection.length) return ordered;

  const newArray = Array.from(collection);
  sortByOrderInPlace(newArray);

  return newArray;
}
